import isEmpty from "lodash/isEmpty";
import { StyleSheet } from "react-native";
import { handleProps } from "./handleProps";

export const transformProps = (props, appendStyles, colorScheme) => {
    
    const resolved = handleProps({...props, colorScheme: colorScheme});
    
    if (Array.isArray(appendStyles)) {
        resolved.push(...appendStyles);
    } else if (!isEmpty(appendStyles)) {
        resolved.push(appendStyles);
    }
    
    return StyleSheet.flatten(resolved)
}